module.exports = __webpack_public_path__ + "static/salma2-fa22fca26a8e7bbb4f006851877d3d58.png";